import { Routes as configRoutes } from '../config/Routes';
import ValidateToken from '../pages/Session/ValidateToken';
import Login from '../pages/Session/Login';
import ForgotPass from '../pages/Session/ForgotPass';
import SignUp from '../pages/Merchants/SignUp';
import Unauthorized from '../pages/Session/Unauthorized';
import AuthMFA from '../pages/Session/AuthMFA';
import SignUpGenericReferrals from '../pages/Referrals/GenericReferralSignUp';
import { OlaClickSignUpReferrals } from '../pages/Referrals/Merchants/Olaclick/OlaClickSignUpReferrals';
import { OrderEatSignUpReferrals } from '../pages/Referrals/Merchants/OrderEat/OrderEatSignUpReferrals';
import { DynamicReferralSignUp } from '../pages/Referrals/DynamicReferralSignUp';

export default [
  {
    Component: ValidateToken,
    path: configRoutes.VALIDATE_TOKEN,
  },
  {
    Component: Login,
    path: configRoutes.HOME,
  },
  {
    Component: Login,
    path: configRoutes.LOGIN,
  },
  {
    Component: AuthMFA,
    path: configRoutes.LOGIN_MFA,
  },
  {
    Component: ForgotPass,
    path: configRoutes.FORGOT_PASS,
  },
  {
    Component: Unauthorized,
    path: configRoutes.UNAUTHORIZED,
  },
  {
    Component: SignUp,
    path: configRoutes.SIGN_UP,
  },
  {
    Component: DynamicReferralSignUp,
    path: configRoutes.SIGN_UP_OLACLICK_REFERRALS_MX,
  },
  {
    Component: OlaClickSignUpReferrals,
    path: configRoutes.SIGN_UP_OLACLICK_REFERRALS,
  },
  {
    Component: OrderEatSignUpReferrals,
    path: configRoutes.SIGN_UP_ORDER_EAT_REFERRALS,
  },
  {
    Component: DynamicReferralSignUp,
    path: configRoutes.SIGN_UP_DYNAMIC_REFERRALS,
  },
  {
    Component: SignUpGenericReferrals,
    path: configRoutes.SIGN_UP_GENERIC_REFERRALS,
  },
];
